import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function AddDriver() {
   const navigate = useNavigate();
   const [form, setForm] = useState({
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      dob: "",
      country: "",
      street: "",
      city: "",
      borough: "",
      state: "NY",
      zip: "",
      payment: "",
      password: "",
      confirmPassword: "",
      licenseNumber: "",
      licensePlate: "",
      vehicleBrand: "",
      vehicleModel: "",
      vehicleYear: "",
      vehicleColor: "",
      rc_id: sessionStorage.getItem("rc_id") || "",

   });

   const [zipCheckResult, setZipCheckResult] = useState(null);
   const [submitting, setSubmitting] = useState(false);
   const [passwordError, setPasswordError] = useState("");
   const [message, setMessage] = useState(null);
   const [centers, setCenters] = useState([]);
   useEffect(() => {
      const fetchCenters = async () => {
         try {
            const res = await axios.get("/auth/redemption-centers");
            setCenters(res.data);
         } catch (err) {
            console.error(err);
         }
      };
      fetchCenters();
   }, []);


   const handleChange = (e) => {
      const { name, value } = e.target;
      setForm((prevForm) => ({
         ...prevForm,
         [name]: value,
      }));
      if (name === "zip" || name === "borough") {
         setZipCheckResult(null); // Reset ZIP check result if changed
      }
   };

   const handleZipCheck = async () => {
      try {
         const res = await axios.post("/auth/check-service-area", {
            state: form.state,
            borough: form.borough,
            zipcode: form.zip,
         });
         setZipCheckResult({ available: true, message: res.data.message });
         toast.success(res.data.message);
      } catch (err) {
         const msg = err.response?.data?.message || "Error checking ZIP availability.";
         setZipCheckResult({ available: false, message: msg });
         toast.error(msg);
      }
   };

   const handleSubmit = async (e) => {
      e.preventDefault();

      if (form.password !== form.confirmPassword) {
         toast.error("Passwords do not match.");
         return;
      }

      setSubmitting(true);

      try {
         const payload = {
            ...form,
            address: form.street,
            paymentMethod: form.payment,
            userType: "driver",
            rc_id: form.rc_id
         };
         delete payload.confirmPassword;

         const res = await axios.post("/auth/drivers/register", payload);
         toast.success(res.data.message);
         setTimeout(() => navigate("/redem-driverlist"), 2000);
      } catch (err) {
         toast.error(err.response?.data?.message || "Registration failed.");
      } finally {
         setSubmitting(false);
      }
   };

   return (
      <section className="px-4 sm:px-6 lg:px-8 py-8">
         <div className="bg-white max-w-4xl mx-auto p-6 sm:p-8 rounded-2xl shadow-lg">
            <h1 className="text-3xl font-bold text-center text-green-700 mb-8">Add Driver</h1>

            <form className="space-y-6" onSubmit={handleSubmit}>
               <div className="grid gap-4 sm:grid-cols-2">
                  <Input label="First Name *" name="firstName" value={form.firstName} onChange={handleChange} required />
                  <Input label="Last Name *" name="lastName" value={form.lastName} onChange={handleChange} required />
               </div>

               <div className="grid gap-4 sm:grid-cols-2">
                  <Input label="Email *" name="email" type="email" value={form.email} onChange={handleChange} required />
                  <Input label="Phone Number *" name="phone" value={form.phone} onChange={handleChange} required />
               </div>

               <div className="grid gap-4 sm:grid-cols-2">
                  <Input label="Date of Birth" name="dob" type="date" value={form.dob} onChange={handleChange} />
                  <Select label="Country" name="country" value={form.country} onChange={handleChange} options={["India", "USA", "UK"]} />
               </div>

               <Input label="Street Address" name="street" value={form.street} onChange={handleChange} />

               <div className="grid gap-4 sm:grid-cols-2">
                  <Input label="City" name="city" value={form.city} onChange={handleChange} />
                  <Select label="Borough" name="borough" value={form.borough} onChange={handleChange} options={["Bronx", "Queens", "Manhattan", "Brooklyn", "Staten Island"]} />
               </div>

               <div className="grid gap-4 sm:grid-cols-3">
                  <Input label="State" name="state" value="NY" readOnly />
                  <Input label="ZIP" name="zip" value={form.zip} onChange={handleChange} />
                  <div className="flex items-end">
                     <button type="button" onClick={handleZipCheck} className="w-full px-4 py-2 bg-[#54BE73] text-white rounded-md hover:bg-green-700">
                        Check Availability
                     </button>
                  </div>
               </div>

               {zipCheckResult && (
                  <div className={`text-sm ${zipCheckResult.available ? "text-green-600" : "text-red-600"}`}>
                     {zipCheckResult.message}
                  </div>
               )}

               <div className="grid gap-4 sm:grid-cols-2">
                  <Input label="Driver License Number" name="licenseNumber" value={form.licenseNumber} onChange={handleChange} />
                  <Input label="License Plate Number" name="licensePlate" value={form.licensePlate} onChange={handleChange} />
               </div>

               <div className="grid gap-4 sm:grid-cols-2">
                  <Input label="Vehicle Brand" name="vehicleBrand" value={form.vehicleBrand} onChange={handleChange} />
                  <Input label="Vehicle Model" name="vehicleModel" value={form.vehicleModel} onChange={handleChange} />
               </div>

               <div className="grid gap-4 sm:grid-cols-2">
                  <Input label="Vehicle Year" name="vehicleYear" value={form.vehicleYear} onChange={handleChange} />
                  <Input label="Vehicle Color" name="vehicleColor" value={form.vehicleColor} onChange={handleChange} />
               </div>

               <Select label="Payment Method" name="payment" value={form.payment} onChange={handleChange} options={["Cash", "Ev-voucher", "Fuel-Voucher", "Stock-credit", "Check by Mail", "ACH", "PayPal"]} />

               <div className="grid gap-4 sm:grid-cols-2">
                  <Input label="Password *" name="password" type="password" value={form.password} onChange={handleChange} required />
                  <Input label="Confirm Password *" name="confirmPassword" type="password" value={form.confirmPassword} onChange={handleChange} required />
               </div>

               <div className="flex justify-end gap-4 pt-2">
                  <button type="button" onClick={() => navigate("/redem-driverlist")} className="px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300">Cancel</button>
                  <button type="submit" disabled={submitting} className="px-6 py-2 rounded-lg bg-green-600 text-white hover:bg-green-700 disabled:opacity-50">
                     {submitting ? "Submitting..." : "Submit"}
                  </button>
               </div>
            </form>
            <ToastContainer position="top-right" autoClose={3000} />
         </div >
      </section >
   );
}

// 🔄 Updated reusable Input component
const Input = ({ label, name, type = "text", value, onChange, readOnly, required }) => (
   <div>
      <label htmlFor={name} className="block mb-1 font-medium">{label}</label>
      <input
         id={name}
         name={name}
         type={type}
         value={value}
         onChange={onChange}
         required={required}
         readOnly={readOnly}
         className={`w-full rounded-lg p-3 ring-1 ${readOnly ? "bg-gray-100" : "bg-lime-50"} ring-gray-300`}
      />
   </div>
);

// Updated reusable Select component
const Select = ({ label, name, value, onChange, options }) => (
   <div>
      <label htmlFor={name} className="block mb-1 font-medium">{label}</label>
      <select
         id={name}
         name={name}
         value={value}
         onChange={onChange}
         className="w-full rounded-lg p-3 ring-1 ring-gray-300 bg-lime-50"
      >
         <option value="">Select {label}</option>
         {options.map((opt) => (
            <option key={opt} value={opt}>{opt}</option>
         ))}
      </select>
   </div>
);